// The native sheet has no web build; `Sheet` never routes here on the web.
export function SwmSheet(): null {
  return null;
}
